import React, { useState } from 'react';
import { FAQ } from '../data/config';

// ── FAQ SECTION ───────────────────────────────────────────────
// Edit questions and answers in src/data/config.js → FAQ array

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" style={{ padding: '80px 24px', background: '#F5F0F0' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div className="section-header">
          <span className="section-label">Got Questions?</span>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Everything you need to know about joining and participating in SHPE@VT.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {FAQ.map((item, i) => (
            <div
              key={i}
              style={{
                background: 'white', borderRadius: 14,
                border: `2px solid ${open === i ? '#861F41' : '#EEE'}`,
                overflow: 'hidden', transition: 'border-color 0.25s ease',
              }}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                style={{
                  width: '100%', textAlign: 'left',
                  padding: '20px 24px', background: 'none', border: 'none',
                  cursor: 'pointer', display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center', gap: 16,
                }}>
                <span style={{ fontSize: 16, fontWeight: 600, color: '#1A1A1A', lineHeight: 1.4 }}>
                  {item.question}
                </span>
                <span style={{
                  width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                  background: open === i ? '#861F41' : '#F0E8E8',
                  color: open === i ? 'white' : '#861F41',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, transition: 'all 0.25s ease',
                  transform: open === i ? 'rotate(45deg)' : 'none',
                }}>
                  +
                </span>
              </button>

              {open === i && (
                <div style={{
                  padding: '0 24px 22px', color: '#555',
                  fontSize: 15, lineHeight: 1.8,
                  animation: 'fadeInUp 0.2s ease',
                  borderTop: '1px solid #F0E8E8',
                  paddingTop: 18,
                }}>
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Still have questions? */}
        <div style={{ textAlign: 'center', marginTop: 48 }}>
          <p style={{ color: '#888', fontSize: 15, marginBottom: 16 }}>
            Still have questions? We're happy to help.
          </p>
          <a href="mailto:shpevt@gmail.com" className="btn btn-primary">
            Email Us →
          </a>
        </div>
      </div>
    </section>
  );
}
